{
  "type": "object",
  "properties": {
    "Manufacturer": { "type": "string", "minLength": 1 },
    "ManufacturersModelName": { "type": "string", "minLength": 1 },
    "DeviceSerialNumber": { "type": "string", "minLength": 1 },
    "StationName": { "type": "string", "minLength": 1 },
    "SoftwareVersions": { "type": "string", "minLength": 1 },
    "InstitutionName": { "type": "string", "minLength": 1 },
    "InstitutionAddress": { "type": "string", "minLength": 1 },
    "InstitutionalDepartmentName": { "type": "string", "minLength": 1 },
    "BodyPart": { "type": "string", "minLength": 1 },
    "BodyPartDetails": { "type": "string", "minLength": 1 },
    "BodyPartDetailsOntology": {
      "type": "string",
      "minLength": 1,
      "format": "uri"
    },
    "SampleEnvironment": {
      "type": "string",
      "minLength": 1,
      "enum": ["in vivo", "ex vivo", "in vitro"]
    },
    "SampleEmbedding": { "type": "string", "minLength": 1 },
    "SampleFixation": { "type": "string", "minLength": 1 },
    "SampleStaining": {
      "anyOf": [
        { "type": "string", "minLength": 1 },
        { "type": "array", "items": { "type": "string" } }
      ]
    },
    "SamplePrimaryAntibody": {
      "anyOf": [
        { "type": "string", "minLength": 1 },
        { "type": "array", "items": { "type": "string" } }
      ]
    },
    "SampleSecondaryAntibody": {
      "anyOf": [
        { "type": "string", "minLength": 1 },
        { "type": "array", "items": { "type": "string" } }
      ]
    },
    "SliceThickness": { "type": "number", "exclusiveMinimum": 0 },
    "SampleExtractionProtocol": { "type": "string", "minLength": 1 },
    "SampleExtractionInstitution": { "type": "string", "minLength": 1 },
    "TissueDeformationScaling": { "type": "number" },
    "PixelSize": {
      "type": "array",
      "minItems": 2,
      "maxItems": 3,
      "items": { "type": "number", "minimum": 0 }
    },
    "PixelSizeUnits": { "type": "string", "enum": ["mm", "um", "nm"] },
    "Immersion": { "type": "string", "minLength": 1 },
    "NumericalAperture": { "type": "number", "exclusiveMinimum": 0 },
    "Magnification": { "type": "number", "exclusiveMinimum": 0 },
    "ImageAcquisitionProtocol": { "type": "string", "minLength": 1 },
    "OtherAcquisitionParameters": { "type": "string", "minLength": 1 },
    "ChunkTransformationMatrix": {
      "anyOf": [
        {
          "type": "array",
          "minItems": 3,
          "maxItems": 3,
          "items": {
            "type": "array",
            "minItems": 3,
            "maxItems": 3,
            "items": { "type": "number" }
          }
        },
        {
          "type": "array",
          "minItems": 4,
          "maxItems": 4,
          "items": {
            "type": "array",
            "minItems": 4,
            "maxItems": 4,
            "items": { "type": "number" }
          }
        }
      ]
    },
    "ChunkTransformationMatrixAxis": {
      "type": "array",
      "minItems": 2,
      "maxItems": 3,
      "items": { "type": "string" }
    }
  },
  "required": ["PixelSize", "PixelSizeUnits"],
  "recommended": [
    "Manufacturer",
    "ManufacturersModelName",
    "DeviceSerialNumber",
    "StationName",
    "SoftwareVersions",
    "InstitutionName",
    "InstitutionAddress",
    "InstitutionalDepartmentName",
    "BodyPart",
    "BodyPartDetails",
    "SampleEnvironment",
    "SampleStaining",
    "SamplePrimaryAntibody",
    "SampleSecondaryAntibody"
  ],

  "dependencies": {
    "PixelSize": ["PixelSizeUnits"],
    "ChunkTransformationMatrix": ["ChunkTransformationMatrixAxis"]
  }
}
